import { useState } from 'react';

function App() {

  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const handleSearch = async e => {
    e.preventDefault();
    if (search === '') return;

    const endpoint = `https://api.moe.gov.bz/api/v1/status/${search}`;
    const response = await fetch(endpoint);
    const json = await response.json();

    setResults(json)
  }

  return (
    <div className="App">
      <header>
        <h1>Grant check</h1>
        <form className="search-box" onSubmit={handleSearch}>
          <input 
            type="search"
            placeholder="Enter your Reference Code - GRANT-XXXXXX."
            value={search}
            onChange={e => setSearch(e.target.value)}
            />
        </form>
      </header>
      <div className="results">
        <div className="result">
          { (results.message) ? <h3>{results.message}</h3> : '' }
          { (results.last_updated) ? <p>Last Updated: {results.last_updated}</p> : '' }
          { (results.program) ? <p>Program: {results.program}</p> : '' }
          { (results.status) ? <h2>Status: {results.status}</h2> : '' }
        </div>
      </div>
    </div>
  );
}

export default App;
